import { LeadGroups } from './leadGroups';
import { Routes } from './routes';

export const NAVIGATION_ITEMS = [
    { to: Routes.OVERVIEW, exact: true, label: 'Overview' },
    { to: Routes.RECOMMENDED, label: LeadGroups.RECOMMENDED },
    { to: Routes.CONTACTED, label: LeadGroups.CONTACTED },
    {
        to: Routes.ACTIVE_CONVERSATIONS,
        label: LeadGroups.ACTIVE_CONVERSATION,
    },
    { to: Routes.LISTED, label: LeadGroups.LISTED },
    { to: Routes.SOLD, label: LeadGroups.SOLD },
    {
        to: Routes.ARCHIVE,
        label: LeadGroups.ARCHIVED,
    },
];
